import { lazy, Suspense } from 'react'
import {
  Routes,
  Route,
  Navigate,
  BrowserRouter,
  Outlet,
} from 'react-router-dom'

import { EmptyPageLoader } from 'components/Loader'
import { RequiredAuthWrapper } from 'components/RequiredAuthWrapper'
import { AppContextsWrapper } from 'routes/AppContextsWrapper'
import { LayoutBlackWithLogo } from 'routes/components/LayoutBlackWithLogo'

// Lazy-loaded route components
const WorkspaceRoutes = lazy(() => import('routes/Workspaces/Workspace'))
const AdminRoutes = lazy(() => import('routes/Admin'))
const AnonymousDocsRoutes = lazy(() => import('routes/Docs'))
const LoginPage = lazy(() => import('routes/LoginPage'))
const WelcomePage = lazy(() => import('routes/WelcomePage'))
const ManageOrgInvitation = lazy(() => import('routes/OrgInvitations'))
const InitialWorkspacePage = lazy(() => import('routes/InitialWorkspace'))

export function AppRoutes() {
  return (
    <Suspense fallback={<EmptyPageLoader />}>
      <BrowserRouter>
        <Routes>
          <Route
            element={
              <AppContextsWrapper>
                <Outlet />
              </AppContextsWrapper>
            }
          >
            <Route path='/' element={<Navigate to='/w/0' replace />} />
            <Route path='/w' element={<Navigate to='/w/0' replace />} />
            <Route
              path='/w/:workspaceId/*'
              element={
                <RequiredAuthWrapper>
                  <WorkspaceRoutes />
                </RequiredAuthWrapper>
              }
            />
            <Route
              path='/admin/*'
              element={
                <RequiredAuthWrapper>
                  <AdminRoutes />
                </RequiredAuthWrapper>
              }
            />
            <Route path='/docs/*' element={<AnonymousDocsRoutes />} />
            <Route path='/login' element={<LoginPage />} />
            <Route path='/welcome' element={<WelcomePage />} />
            <Route
              path='/org-invitations/:id'
              element={
                <RequiredAuthWrapper>
                  <LayoutBlackWithLogo>
                    <ManageOrgInvitation />
                  </LayoutBlackWithLogo>
                </RequiredAuthWrapper>
              }
            />
            <Route
              path='/workspace-invitations/:id'
              element={
                <RequiredAuthWrapper>
                  <LayoutBlackWithLogo>
                    <ManageOrgInvitation />
                  </LayoutBlackWithLogo>
                </RequiredAuthWrapper>
              }
            />
            <Route
              path='/initial-workspace'
              element={
                <RequiredAuthWrapper>
                  <InitialWorkspacePage />
                </RequiredAuthWrapper>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </Suspense>
  )
}
